<template>
  <div class="footer">
    <button class="footer-contact-us-button" @click="onClickBtn">联系我们</button>
    <span class="footer-contact-us-title">获取您的专属项目解决方案</span>
    <img class="footer-logo" src="@/assets/images/logo_white.webp" alt="">
    <span class="footer-line"></span>
    <img class="footer-logo-font" src="@/assets/images/ic_logo_font.webp" alt="">
    <div class="footer-address"><strong>地址:</strong><br>北京市经济技术开发区隆庆街9号1号楼</div>
    <div class="footer-phone"><strong>电话:</strong><br>+86-010-67864680</div>
    <div class="footer-email"><strong>邮箱:</strong><br>BD@yiconmed.com / HR@yiconmed.com</div>
    <span class="footer-license">版权所有：亦康（北京）医药科技有限公司&nbsp;&nbsp;&nbsp;备案号：京ICP备20016765号-1</span>
  </div>
</template>

<script setup>
import router from "@/router/router.js"

const onClickBtn = () => {
  // 在路由跳转后滚动到页面顶部
  router.push({path: '/contact'}).then(() => {
    window.scrollTo(0, 0)
  })
}

</script>

<style scoped lang="less">

.footer {
  position: absolute;
  width: 100%;
  height: 380px;
  background-image: url('@/assets/images/footer_bg.webp'); /* 背景图路径 */
  background-size: cover; /* 背景图覆盖整个容器 */
  background-position: center; /* 背景图居中 */
  background-repeat: no-repeat;
  overflow: hidden;

  .footer-contact-us-button {
    position: absolute;
    font-size: 16px;
    padding: 15px 60px;
    top: 70px;
    left: 50%;
    transform: translate(-50%, 0);
    color: #fff;
    background-color: transparent;
    border: 1px solid #F3AA70; /* 设置透明边框，利用背景做渐变 */
    border-radius: 36px; /* 圆角 */
    cursor: pointer;
    letter-spacing: 1px;
    transition: all 0.3s ease;

    &:hover {
      background-image: linear-gradient(45deg, #ff7e5f, #feb47b); /* 渐变色 */
    }
  }

  .footer-contact-us-title {
    position: absolute;
    font-family: 时尚中黑简体, serif;
    color: #fff;
    font-size: 22px;
    top: 150px;
    left: 50%;
    letter-spacing: 1px;
    transform: translate(-50%, 0);
  }

  .footer-logo {
    position: absolute;
    bottom: 93px;
    left: 240px;
    height: 63px;
    width: 167px;
    object-fit: cover;
    object-position: center;
  }

  .footer-line {
    position: absolute;
    bottom: 96px;
    left: 421px;
    width: 2px;
    height: 52px;
    background: #fff;
    border-radius: 2px;
  }

  .footer-logo-font {
    position: absolute;
    width: 180px;
    height: 32px;
    bottom: 108px;
    left: 433px;
    object-fit: cover;
    object-position: center;
  }

  .footer-address {
    position: absolute;
    color: #fff;
    left: 729px;
    font-size: 14px;
    line-height: 22px;
    bottom: 102px;
  }

  .footer-phone {
    position: absolute;
    color: #fff;
    left: 1120px;
    font-size: 14px;
    line-height: 22px;
    bottom: 102px;
  }

  .footer-email {
    position: absolute;
    color: #fff;
    right: 224px;
    font-size: 14px;
    line-height: 22px;
    bottom: 102px;
  }

  .footer-license {
    position: absolute;
    bottom: 45px;
    font-size: 12px;
    color: #878787;
    left: 50%;
    letter-spacing: 1px;
    transform: translate(-50%, 0);
  }
}

</style>
